import React from "react";
import styles from "../styles/QFilters.module.css";

function Chips({
    options,
    multiple,
    val,
    onChange,
    styles_parsed,
    alignItems,
}) {
    return (
        <div
            className={styles.chips_wrapper}
            style={{
                justifyContent: alignItems,
            }}
        >
            {options.map((option, index) => {
                if (option.label === "") {
                    return <></>;
                }
                const is_selected = multiple
                    ? val.includes(option.value)
                    : val === option.value;
                return (
                    <div
                        key={index}
                        className={styles.chips}
                        onMouseDown={() => onChange(option.value, index)}
                        style={{
                            ...styles_parsed.normal,
                            ...(is_selected ? styles_parsed.selected : {}),
                            cursor: "pointer",
                        }}
                    >
                        {option.label}
                    </div>
                );
            })}
        </div>
    );
}

export default Chips;
